import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import {
    ConversationsActionType,
    ConversationsAction,
    LoadConversationsAction,
    LoadConversationsFailedAction,
    LoadConversationsSucceededAction,
    CreateNewConversationAction,
    CreateNewConversationSucceededAction,
    CreateNewConversationFailedAction,
} from './conversations.actions';
import {
    ConversationsService
} from '../../firebase/conversations.service';
import { SopoLoadingService } from 'src/app/shared/services/sopo-loading/sopo-loading.service';


@Injectable()
export class ConversationsEffects {

    
    createNewConversation$: Observable < ConversationsAction > = createEffect(() => this.actions$
        .pipe(
            ofType(ConversationsActionType.CREATE_NEW_CONVERSATION),
            switchMap((action: CreateNewConversationAction) => {
                return from(this.conversationsService.createNewConversation(action.userID)
                    .then(() => {
                        return new CreateNewConversationSucceededAction();
                    })
                    .catch(error => {
                        return new CreateNewConversationFailedAction({
                            'error': error
                        });
                    })
                );
            })
        ));

    
    loadConversations$: Observable < ConversationsAction > = createEffect(() => this.actions$
        .pipe(
            ofType(ConversationsActionType.LOAD_CONVERSATIONS),
            switchMap((action: LoadConversationsAction) => {
                return from(this.conversationsService.loadConversations()
                    .then(conversations => {
                        return new LoadConversationsSucceededAction(conversations);
                    })
                    .catch(error => {
                        return new LoadConversationsFailedAction({
                            'error': error
                        });
                    })
                );
            })
        ));

    constructor(private conversationsService: ConversationsService,
        private actions$: Actions,
        private loadingCtrl: SopoLoadingService) { }
}
